import
{
    newCourseDetail, searchCourseList
} from "@/api/course";


const state = {
}

const mutations = {
}

const actions = {
    newcoursedetail({commit}, data) {
        return new Promise((resolve, reject) => {
        newCourseDetail(data).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
        })
    },
    searchcourselist({commit}, params) {
        return new Promise((resolve, reject) => {
        searchCourseList(params).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
        })
    }

}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
